import { t as formatMoney } from "./app.shared-DrMetWk9.js";

var variant_price_default = (() => {
    if (customElements.get("variant-price")) return;
    customElements.define("variant-price", class VariantPrice extends HTMLElement {
        connectedCallback() {
            this.productId = this.dataset.productId ? +this.dataset.productId : null;
            this.inModal = !!this.closest(".ajax-modal");
            document.addEventListener("variant:change", this.onChange);
        }
        disconnectedCallback() {
            document.removeEventListener("variant:change", this.onChange);
        }
        onChange=event => {
            if (!!event.detail.modal !== this.inModal) return;
            if (this.productId !== null && event.detail.productId !== this.productId) return;
            this.render(event.detail.variant);
        };
        render(variant) {
            if (!variant) return;
            const price = variant.price;
            const compareAtPrice = variant.compare_at_price || 0;
            const isOnSale = compareAtPrice > price;
            this.querySelectorAll("[data-price]").forEach(el => {
                el.innerHTML = formatMoney(price);
                const wrapper = el.parentElement;
                if (!wrapper?.hasAttribute("data-is-atc")) el.classList.toggle("text-red", isOnSale); else {
                    wrapper.classList.toggle("hidden", !variant.available);
                    wrapper.classList.toggle("flex", variant.available);
                }
            });
            this.querySelectorAll("[data-compare-at-price]").forEach(el => {
                const isAtc = el.parentElement?.hasAttribute("data-is-atc");
                el.innerHTML = isOnSale && !isAtc ? formatMoney(compareAtPrice) : "";
            });
        }
    });
})();